import React from 'react';
import { useNavigate } from 'react-router-dom';
import PrivacyModal from '../ui/PrivacyModal';

const PrivacyRoute = () => {
    const navigate = useNavigate();

    const handleClose = () => {
        navigate(-1);
    };

    return (
        <PrivacyModal forceOpen isStandalone onCloseOverride={handleClose} />
    );
};

export default PrivacyRoute;

